import { LogicCashTodayServiceMock } from "./logicCashToday.types";

export const mockLogicCashTodayService = (): LogicCashTodayServiceMock => ({
  fetchLogicCashTodays: jest.fn(),
});
